import React from "react";
import { Chip, ChipProps } from "@mui/material";
import { DIFFICULTY_LABELS } from "../../types";

interface DifficultyChipProps {
  difficulty: number;
  size?: ChipProps["size"];
  variant?: ChipProps["variant"];
  sx?: ChipProps["sx"];
}

/**
 * 難易度に応じた背景色を返す
 * 1: 緑, 2: 黄緑, 3: オレンジ, 4: 朱色, 5: 赤
 */
function getDifficultyChipColor(difficulty: number): string {
  const colors: Record<number, string> = {
    1: "#4CAF50",
    2: "#8BC34A",
    3: "#FF9800",
    4: "#FF5722",
    5: "#F44336",
  };
  return colors[difficulty] || "#FF9800";
}

const DifficultyChip: React.FC<DifficultyChipProps> = ({
  difficulty,
  size = "small",
  variant = "filled",
  sx,
}) => {
  const label =
    difficulty in DIFFICULTY_LABELS
      ? DIFFICULTY_LABELS[difficulty as keyof typeof DIFFICULTY_LABELS]
      : `難易度${difficulty}`;

  return (
    <Chip
      label={label}
      size={size}
      variant={variant}
      sx={{
        backgroundColor: getDifficultyChipColor(difficulty),
        color: "#fff",
        ...sx,
      }}
    />
  );
};

export default DifficultyChip;
